import React from 'react';
import { IconButton, CircularProgress } from '@mui/material';
import { CloudDownload } from '@mui/icons-material';
import useExitStatement from 'hooks/data/exit/useExitStatement';
import { useBulkDownloadExitStatementPdf } from 'hooks/data/investorReporting/useBulkDownloadExitStatementPdf';
import api from 'lib/trpcClient';

type Props = {
  exitId?: string;
  selectedInvestors: Array<{
    _id: string;
    fullName: string;
  }>;
};

const DownloadPdfExitStatementButton: React.FC<Props> = ({
  exitId,
  selectedInvestors,
}) => {
  const exit = api.exit.getById.useQuery(
    { id: exitId ?? '' },
    { enabled: !!exitId },
  );
  const exitStatementId = exit?.data?.exitStatement?._id;

  const { exitStatement: exitStatementResponse } = useExitStatement({
    id: exitStatementId,
  });
  const exitStatement = exitStatementResponse?.data?.exitStatement;

  const bulk = useBulkDownloadExitStatementPdf(
    exitStatementId || '',
    exitStatement || {},
    selectedInvestors,
  );

  const isReady =
    !!exitStatementId && !!exitStatement && selectedInvestors.length > 0;

  return (
    <IconButton
      title="Download"
      onClick={() => bulk.mutate()}
      disabled={!isReady || bulk.isPending}
      size="large"
    >
      {bulk.isPending ? (
        <CircularProgress size={24} />
      ) : (
        <CloudDownload color={isReady ? 'primary' : 'disabled'} />
      )}
    </IconButton>
  );
};

export default DownloadPdfExitStatementButton;
